var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 26.71" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_infoshare"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_information" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icon_infoshare" },
            React.createElement("path", { id: "item_infoshare1", className: styles["cls-1"] || "cls-1", d: "M13.85 4.35L9.5 0 5.15 4.35l.7.71L9 1.91v9.8h1v-9.8l3.15 3.15.7-.71z" }),
            React.createElement("path", { id: "item_infoshare2", className: styles["cls-1"] || "cls-1", d: "M13 7.71v1h5v17H1v-17h5v-1H0v19h19v-19h-6z" }),
            React.createElement("path", { id: "item_infoshare3", className: styles["cls-1"] || "cls-1", d: "M19 17l-3.05-3.05-3 4L10 15l-2 2-4.03-4.03L0 17.73v1.56l4.03-4.84L8 18.41l2-2 3.05 3.06 3-4 2.6 2.59.35-.35V17z" })
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/icon/images/share.svg
// module id = 1060
// module chunks = 0